import React, { Component } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
} from "../../../common/component/Index";
import i18n from "../../../../../constants/initLng";
import DEFINE, { PATHS, UPLOAD_DIRECTORY, SUPPLIER, FEATURE_FLAGS, VALIDATE_ENUM, DETAIL_ACTIONS, DATE_TIME_FORMAT, INSTALLMENT as INSTALLMENT_ENUM } from "../../../../../constants/Define";
import { message } from 'antd';
import { isEqual, get, cloneDeep, uniqBy } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import Supplier from '../../../../../models/Supplier';
import Wrapper from './../../../common/component/Wrapper';
import SupplierInfo from './SupplierInfo';
import SupplierInfoDetail from './SupplierInfoDetail';
import ContractInfo from './ContractInfo';
import TranslateButton from './../../../common/component/TranslateButton/index';

import { getNapasReconEmailConfig, updateNapasReconEmailConfig } from '../../../../../services/napasReconEmailService';

import './SupplierDetail.less';
import AutoTranslate from 'containers/backend/common/component/AutoTranslate/AutoTranslate';

const defaultState = {
    action: "CREATE",
    validation: {},
};

export default class SupplierDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            supplier: this.props.supplierState.detail.supplier,
            uploadFiles: [],
            typeCheckCode: false,
            validateTabContent: [],
            updateSuccess: false,
            isDetailLoaded: !this.props.match.params.id,
            napasReconEmail: undefined,
            expiryMinutes: undefined,
        };
    }

    componentDidMount() {
        this.initDetail()
    }

    componentWillUnmount() {
        this.props.setSupplierDetail(new Supplier())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.supplierState.detail.supplier && !isEqual(nextProps.supplierState.detail.supplier, this.props.supplierState.detail.supplier)) {
            this.setState({
                supplier: nextProps.supplierState.detail.supplier,
                action: nextProps.supplierState.detail.supplier.id ? 'UPDATE' : this.state.action,
                updateSuccess: true,
                isDetailLoaded: true
            }, () => {
                setTimeout(() => {
                    this.setState({ updateSuccess: false });
                }, 100);
            });
            this.getNapasReconEmail(nextProps.supplierState.detail.supplier.code);
        }
        if (nextProps.uploadState.file && !isEqual(nextProps.uploadState.file, this.props.uploadState.file)) {
            this.processUploadedFiles(nextProps.uploadState.file);
        }
    }

    render() {
        const { t, supplierState, uploadState } = this.props;
        const { isFetchingDetail, isFetchingProduct, supplierProducts, sites } = supplierState;
        const { action, validation, supplier, typeCheckCode, validateTabContent, updateSuccess, isDetailLoaded } = this.state;

        return (
            <LoadingComponent spinning={isFetchingDetail || !isDetailLoaded}>
                <PageListComponent className="supplier-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'suppliers'}
                        titleHeader={action === "CREATE"
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.supplier.title')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.supplier.title')}`.toLowerCase()))
                        }
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                            <TranslateButton
                                languages={supplier.translations}
                                current={supplier.languageCode}
                                validation={validation.languageCode}
                                onChange={this.onShowTranslate}
                                onClear={this.onExitTranslate}
                                defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                onSelectDefault={language => this.onChangeDetail('languageCode', language.code)}
                                onRemove={this.onRemoveTranslate} />
                        }

                    />
                    {isDetailLoaded && <FormActionComponent
                            onSubmit={this.onSubmit}
                            isGetItem={false}
                            action={action}
                            onClickBack={this.onClickBack}
                            submitButtonRight={true}
                        >
                        <div className='col-12 p-0'>
                            <h4 className='p-2'>{t('item.supplier.supplierInfoTitle')}</h4>
                            <Wrapper className='col-md-12 row p-0 m-0 bg-white'>
                                <Wrapper className='col-md-6 p-0 m-0'>
                                    <SupplierInfo
                                        action={action}
                                        supplier={supplier}
                                        supplierProducts={supplierProducts}
                                        loading={isFetchingDetail}
                                        loadingProduct={isFetchingProduct}
                                        uploading={uploadState.isFetchingMultiple}
                                        uploadState={this.props.uploadState}
                                        validation={validation}
                                        sites={sites}
                                        updateSuccess={updateSuccess}
                                        createSupplierFAQs={this.props.createSupplierAddFAQs}
                                        deleteSupplierFAQs={this.props.deleteSupplierFAQs}
                                        supplierFAQs={supplierState.supplierFAQ}
                                        onUploadImage={this.onUploadImages}
                                        onUploadFile={this.props.onUploadFile}
                                        onChange={this.onChangeDetail}
                                        onCreateSupplierProduct={this.props.createSupplierProduct}
                                        onUpdateSupplierProduct={this.props.updateSupplierProduct}
                                        onDeleteSupplierProduct={this.props.deleteSupplierProduct}
                                        onGetVinWonderSites={this.props.getVinWonderSites}
                                    />
                                </Wrapper>
                                <Wrapper className='col-md-6 p-0 m-0'>
                                    <ContractInfo supplier={supplier}
                                        loading={isFetchingDetail}
                                        validation={validation}
                                        typeCheckCode={typeCheckCode}
                                        action={action}
                                        napasReconEmail={this.state.napasReconEmail}
                                        onChangeNapasReconEmail={this.onChangeNapasReconEmail}
                                        expiryMinutes={this.state.expiryMinutes}
                                        onChangeNapasExpiryMinutes={this.onChangeNapasExpiryMinutes}
                                        onChange={this.onChangeDetail} />
                                </Wrapper>
                            </Wrapper>
                        </div>

                        {this.state.supplier.isEnableVinwonder && <div className='col-12 p-0 mt-2'>
                            <h4 className='p-2'>{t('item.supplier.supplierInfoDetailTitle')}</h4>
                            <Wrapper className='col-md-12 p-0 m-0 bg-white'>
                                <Wrapper className='col-12 p-0 m-0'>
                                    <SupplierInfoDetail
                                        action={action}
                                        supplier={supplier}
                                        supplierProducts={supplierProducts}
                                        loading={isFetchingDetail}
                                        loadingProduct={isFetchingProduct}
                                        validation={validation}
                                        uploadState={this.props.uploadState}
                                        onUploadFile={this.props.onUploadFile}
                                        onUploadImages={this.onUploadImages}
                                        onRemoveImage={this.removeInfoImages}
                                        onChange={this.onChangeDetail}
                                        validateTabContent={validateTabContent}
                                    />
                                </Wrapper>
                            </Wrapper>
                        </div>}

                        {(action === DETAIL_ACTIONS.UPDATE) && (
                            <AutoTranslate
                                className="wrapper-full"
                                languageCode={supplier?.languageCode || 'vi-VN'}
                                onChange={this.onChangeDetail}
                                targetLanguage={supplier?.targetLanguage}
                            />
                        )}
                    </FormActionComponent>}
                </PageListComponent>
            </LoadingComponent>
        );
    }

    initDetail() {
        const { match } = this.props;
        const params = window.location.pathname.split('/');
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id || params?.[params.length - 1];
            this.setState({ action: "UPDATE", supplier: new Supplier(), isDetailLoaded: false });
            this.props.getSupplierDetail(id);
            this.props.getSupplierDetailAddFAQs(id)
        }
        this.props.getAllSupplierProduct();
    }

    onChangeDetail = (fieldName, value) => {
        const supplier = this.state.supplier;
        supplier[fieldName] = value;
        this.setState({ supplier });
        if(fieldName === 'code'){
            this.onCheckDefineCode(value);
        }
        supplier[fieldName] = value;
        this.setState({ supplier });
    };

    onChangeNapasReconEmail = (value) => {
        this.setState({ napasReconEmail: value });
    };

    onChangeNapasExpiryMinutes = (value) => {
        this.setState({ expiryMinutes: value });
    };

    getNapasReconEmail = (supplierCode) => {
        if (!supplierCode || this.napasFetchedCode === supplierCode) return;
        this.napasFetchedCode = supplierCode;
        getNapasReconEmailConfig({ supplierCode })
            .then(config => this.setState({
                napasReconEmail: config?.emails || undefined,
                expiryMinutes: config?.expiryMinutes ?? undefined
            }))
            .catch(() => { });
    };

    saveNapasReconEmail = (supplierCode) => {
        if (!supplierCode) return Promise.resolve();
        const expiryMinutes = this.state.expiryMinutes;
        return updateNapasReconEmailConfig({
            supplierCode,
            emails: this.state.napasReconEmail || '',
            expiryMinutes: expiryMinutes === '' || expiryMinutes === undefined || expiryMinutes === null
                ? undefined
                : Number(expiryMinutes)
        }).catch(error => {
            message.error(error?.message || i18n.t('validation.statusCode.code.500'));
        });
    };

    onCheckDefineCode = (value)=>{
        let isCheck = false;
        let length = value.length || 0;
        if(length !== 5){
            isCheck = true;
        }
        this.setState({typeCheckCode: isCheck});
    }

    onSubmit = (e) => {
        e.preventDefault();
        const { typeCheckCode } = this.state;
        if (!typeCheckCode && this.validate()) {
            this.updateDetail()
        }
    };

    onClickBack = () => {
        this.props.history.push(PATHS.SUPPLIER.LIST.path);
    }

    validate() {
        const { t } = this.props;
        const { supplier } = this.state;
        let validate = {
            required: {
                supplierName: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.supplierName`)),
                // supplierProduct: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.supplierProduct`)),
                code: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.supplierCode`)),
            },
            isPhone: { 
                phoneNumber: t('validation.isPhone'),
                contactPhoneNumber: t('validation.isPhone')
            },
            isEmail: {
                email: t('validation.email'),
                contactEmail: t('validation.email'),
            },
            isUrl: {
                website: t('validation.isUrl'),
            }
        };
        if(supplier.contractStatus !== SUPPLIER.CONTRACT.STATUS.UNSIGNED.id){
            validate.required.contractNumber = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.contractNumber`));
        }
        if(supplier.contractStatus === SUPPLIER.CONTRACT.STATUS.SIGNED.id){
            validate.required.signedDate = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.signedDate`));
            validate.required.contractEndDate = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.contractEndDate`));
        }
        if(supplier.isEnableVinwonder){
            validate.required.siteCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.siteCode`));
        }
        if(supplier.isEnableVinwonder){
            validate.required.title = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.infoDetail.title`));
        }
        if(supplier.isEnableVinwonder){
            validate.required.shortDescription = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.infoDetail.shortDescription`));
        }
        if(supplier.isEnableVinwonder){
            validate.required.thumbImage = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.infoDetail.thumbImage`));
        }
        if(supplier.isEnableVinwonder){
            validate.required.slideShowImages = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.infoDetail.slideShowImages`));
        }
        if(this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        
        let valueValidate = {};
        const napasResult = Func.multipleValidate(
            { napasReconEmail: this.state.napasReconEmail },
            { isEmailList: { napasReconEmail: t('validation.email') } }
        );
        const result = Func.multipleValidate(this.state.supplier, validate, valueValidate);
        const validationResult = { ...result, ...napasResult };
        this.setState({ validation: validationResult });
        const validateTabContent = !supplier.isEnableVinwonder || this.validateTabContent();
        return Object.keys(validationResult).length < 1 && validateTabContent;;
    }
    
    validateTabContent = () => {
        let result = []
        let isErrors = 0
        const { t } = this.props;
        const supplier = {...this.state.supplier}
        let validate = {
            required: {
                title: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.titleContent`)),
                content: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplier.content`))
            },
            maxLength: { title: Func.formatValidation(t('validation.statusCode.code.4'), 50) },
        };
        let valueValidate = {
            maxLength: { title: 50 }
        };
        supplier.extraInfos.forEach((info, index) => {
            const resultInfo = Func.multipleValidate(info, validate, valueValidate, true);
            if(Object.keys(resultInfo).length > 0) {
                isErrors++
            }
            result.push(resultInfo)
        })
        const uniqTour = uniqBy(supplier.extraInfos, 'title')
        if(supplier.extraInfos.length > uniqTour.length) {
            isErrors++
            message.error('Tiêu đề bài viết không được trùng !')
            return false
        }
        this.setState({ validateTabContent: result });
        return isErrors === 0
    }

    updateDetail() {
        const { supplier, action } = this.state;
        switch (action) {
            case DETAIL_ACTIONS.CREATE:
                this.props.createSupplier(supplier, {
                    onSuccess: () => this.saveNapasReconEmail(supplier.code)
                });
                break;
            case DETAIL_ACTIONS.UPDATE:
                this.props.updateSupplier(supplier, {
                    onSuccess: () => {
                        this.props.getSupplierDetail(supplier.id);
                    }
                });
                this.saveNapasReconEmail(supplier.code);
                break;
                case DETAIL_ACTIONS.TRANSLATE:
                    this.onSaveTranslate(supplier);
                    break;
            default:
                break;
        }
    }

    processUploadedFiles(fileObj) {
        let uploadFiles = this.state.uploadFiles;
        const supplier = this.state.supplier;

        // set image for supplier info detail
        if(fileObj.data.field){
            let fileUrl = fileObj.data.fileUrl;
            if(fileObj.data.isFile === 1){
                this.onChangeDetail(fileObj.data.field, fileUrl);
            }else{
                const listImage = supplier[fileObj.data.field];
                if(listImage == null || (listImage.length && !listImage.includes(fileUrl))){
                    const newData = supplier[fileObj.data.field] == null ? [fileUrl] : [...supplier[fileObj.data.field], fileUrl];
                    this.onChangeDetail(fileObj.data.field, newData);
                }
            }
        }else{
            supplier.setLogo(get(fileObj, 'data.fileUrl'), get(fileObj, 'data.fileName'));
        }
        this.setState({ supplier, uploadFiles });
    }

    onUploadImages = (file) => {
        let fileData = file.target.files;
        let uploadFiles = this.state.uploadFiles;
        if (fileData.length > 6) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 6));
            return false;
        } else if ((uploadFiles.length + fileData.length) > 6) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 6));
            return false;
        }
        let imageValidation = ['image/jpeg', 'image/jpg', 'image/png'];
        Object.keys(fileData).map((i) => {
            if (imageValidation.includes(fileData[i].type)) {
                this.props.onUploadFile({ file: fileData[i], directory: UPLOAD_DIRECTORY.SUPPLIER, isFile: 2 })
            } else {
                message.error(i18n.t('validation.image'))
            }
        })
    }

    removeImages = (i, k) => {
        if (!i) return;
        const supplier = this.state.supplier;
        supplier.removeLogo(i)
        this.setState({ supplier });
    };

    onShowTranslate = (language) => {
        const { supplier } = this.state;
        supplier.setTranslate(language.code);
        supplier.setData();
        this.setState({ supplier, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const supplier = cloneDeep(this.state.supplier);
        const action = DETAIL_ACTIONS[supplier.id ? 'UPDATE' : 'CREATE'];
        supplier.setTranslate(undefined, true);
        supplier.setData();
        this.setState({ supplier, action });
    }

    onRemoveTranslate = (language) => {
        const { supplier } = this.state;
        supplier.setTranslate(language.code);
        this.props.deleteSupplierTranslate(supplier, { id: supplier.id });
    }

    onSaveTranslate = (supplier) => {
        const translateFunction = supplier.translate.id ? this.props.updateSupplierTranslate : this.props.createSupplierTranslate;
        translateFunction(supplier);
        this.onExitTranslate();
    }

}
